import { isEmpty } from 'lodash';

let messages = window['LOCALIZATION_DATA'];

export function gettext(key: string | any, ...params): string {
    if (isEmpty(key)) {
        return '';
    }

    if (key.toJS) {
        key = key.toJS();
        [key, ...params] = key;
    }
    const value = messages[key.toLowerCase()];
    return value ? format(value, params || []) : key;
}

function format(source, params) {
    //portal messages are encapsulated in array
    let result = Array.isArray(source) ? source[0] : source;
    params.forEach((n, i) => {
        result = result.replace(new RegExp('\\{' + i + '\\}', 'g'), function() {
            return n;
        });
    });
    return result;
}

export function addAll(entries) {
    Object.assign(messages, entries);
}

export function getPluralText(key, pluralizeValue, margins = [0, 1, 2, 5]) {
    let resolved;
    margins.forEach(margin => {
        if (pluralizeValue >= margin) {
            resolved = margin;
        }
    });
    return gettext(key + '.plural' + resolved, pluralizeValue);
}

// is used in tests
export function setMessages(newMessages) {
    messages = newMessages;
}

export default gettext;
